module.exports = __webpack_public_path__ + "static/img/flyingTreasureTestimonial.8db38f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/flying-treasure/flyingTreasureTestimonial.jpg
// module id = 48
// module chunks = 0